export default __webpack_public_path__ + "static/media/anonymous.eb494d5d.png";